import styles from "../styles/navbar.module.css";

export default function Navbar() {
    return (
        <nav className={styles.mainctnr}>
            <a href="/" className={styles.brand}>
                <span className={styles.mark} aria-hidden="true" />
                <span className={styles.wordmark}>Cities Rec</span>
            </a>

            <div className={styles.selectctnr}>
                <a href="/" className={styles.link}>Home</a>
                <a href="/about" className={styles.link}>About</a>
                <a href="/model" className={styles.link}>The Model</a>
            </div>
        </nav>
    )
}
